/* global MyFacture, Listing, MyForm */

window.People = {
	prepareFilterForm : function() {
		Listing.updateLocFilter('peopleListing');
		var options = {
			success: function(data) {
				People.processFilterForm(data);
			},
			dataType:"json"
		};
		MyForm.prepare("peopleFilterForm", "people&action=updateListing", options);
	},

	processFilterForm: function(data) {
		Listing.refresh("peopleListing", data, data.people_metadatas);
	},

	loadAgendaTab : function(startTime, endTime, days, view, forceLocation) {
		if ($('#people-fullcalendar table').length === 0) {
			MyFacture.customForm();
			Agenda.initCalendar(startTime, endTime, days, view, forceLocation);
		}
	},

	edit : function(context, peopleid, linkedtype, linkedid) {

		peopleid	= peopleid === undefined ? '' : peopleid;
		linkedtype	= linkedtype === undefined ? 'none' : linkedtype;
		linkedid	= linkedid === undefined ? '' : linkedid;
		context		=  context === undefined ? '' : context;

		var formID = 'peopleForm';

		var data = {
			action		: "editForm",
			peopleid	: peopleid,
			linkedtype	: linkedtype,
			linkedid	: linkedid,
			context		: context
		};

		var options = {
            title : peopleid === '' ? Loc.g('Ajouter un contact') : Loc.g('Editer un contact'),
            dialogClass: "white",
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function() {
						$("#" + formID).submit();
					}
				}
			],
			width: 1000,
			callback: function() {

				var options = {
					success: function(data) {
						var formIsOk = MyForm.processJson(data, formID);
						if (formIsOk) {
							if (data.namesakes != undefined) {
								People.showNamesakes(formID, data.namesakes);
							} else {
								switch (context) {
									case 'listing':
										MyWindow.close();
										Listing.update('peopleListing');
										break;
									case 'thirdOverview':
										MyWindow.close();
										Utils.reload();
										break;
									default :
										Utils.relocate('?_f=people&id='+data.peopleid);
										break;
								}
							}
						}
					},
					dataType: "json",
					data: {
						action: "record",
						context : context
					}
				};

				MyForm.prepare(formID, "people", options, true);
				MyFacture.customForm("#"+formID);
				Qtip.init();

			}
		};

		MyWindow.load("people", data, options);
	},

	linkForm : function(peopleid, linkedtype) {

		var formID = 'peopleLinkForm';
		var options = {
            title : Loc.g('Lier un contact'),
            dialogClass: 'white',
			buttons: [
				{
					text	: Loc.g("Annuler"),
					click	: function() {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					click	: function() {
						$("#" + formID).submit();
					}
				}
			],
			width: 1200,
			callback: function() {
				var options = {
					success: function(data) {
						var formIsOk = MyForm.processJson(data, formID);
						if (formIsOk) {
							Utils.reload();
						}
					},
					dataType: "json",
					data: {
						action: "recordLinkForm"
					}
				};

				var $form = $("#"+formID);
				MyForm.prepare(formID, "people", options, true);
				MyFacture.customForm("#"+formID);

				$form.find('input[name=link_third]').bind('change', function() {
					if ($(this).val() === 'new') {
						$("#newthirdform").slideDown('fast', function() {
							MyFacture.customForm("#newthirdform");
						});
					} else {
						$("#newthirdform:visible").slideUp('fast');
					}
				});
			}
		};

		MyWindow.load("people", {action: "linkForm", peopleid : peopleid}, options);
	},

	unlinkForm: function (peopleid)
	{
		var options = {
			title: Loc.g('Délier le contact'),
			buttons: [
				{
					text : Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Valider"),
					click: function () {
						var i = 0;
						let tabIdLink = [];

						$("#checkBoxUnlinkSociety:checked").each(
							function() {
								tabIdLink[i] = $(this).attr('name');
								i++;
							}
						);

						if (tabIdLink.length === 0) {
							$(this).dialog('close');
							Push.error(Loc.g('Veuillez sélectionner au moins un élément.'));
							return;
						}

						$.post(
							'/?_f=people',
							{
								action: 'removeLinked',
								peopleid: peopleid,
								'linkedid[]': tabIdLink,
							}, function() {
								Utils.reload();
							},
						);
					}
				}
			],
			width: 500,
			callback: function () {
				Qtip.init();
			}
		};

		MyWindow.load("people", {action: "unlinkForm", peopleid : peopleid}, options);
	},

	showNamesakes : function(formID, namesakes) {
		var options = {
			type: "warning",
			resizable: false,
			noclose: true,
			title: Loc.g("Information Sellsy"),
			width : 450,
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Créer"),
					click: function() {
						$(this).dialog("close");
						$('#'+formID+' #checkDuplicate').val('N');
						$('#'+formID).submit();
					}
				}
			]
		};

		var msg = Loc.g("Il existe déjà un ou plusieurs contacts avec ce nom, prénom ou email : ");

		msg += '<div class="table table-light" style="margin:15px 5px;"><table>';
		msg += '<thead><tr>'
			 + '<th>' + Loc.g('Prénom') + '</th>'
			 + '<th>' + Loc.g('Nom') + '</th>'
			 + '<th>' + Loc.g('Email') + '</th>'
			 + '</tr></thead>';

		for (var cpt in namesakes) {
			msg += '<tr>';
			msg += '<td>'+namesakes[cpt].forename+'</td>';
			msg += '<td>'+namesakes[cpt].name+'</td>';
			msg += '<td>'+namesakes[cpt].email+'</td>';
			msg += '</tr>';
		}
		msg += '</table></div>';
		msg += "<p>"+Loc.g("Créer le contact quand même ?")+"</p>";

		MyWindow.alert(msg, options);
	},

	linkTo : function(linkedtype, linkedid) {

		var formID = 'peopleLinkToForm';
		var options = {
			title	: Loc.g('Ajouter / Lier un contact'),
			dialogClass : "white",
			width	: 1200,
			height	: 'auto',
			buttons	: [
				{
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function() {
						$("#" + formID).submit();
					}
				}
			],
			callback: function() {
				var options = {
					success: function(data) {
						var formIsOk = MyForm.processJson(data, formID);

						if (formIsOk) {
							if (data.namesakes != undefined) {
								People.showNamesakes(formID, data.namesakes);
							} else {
								switch(data.linkedtype){
									case 'email' :
										MyWindow.close();
										Listing.update('emailsListing', false);
								}
							}
						}
					},
					dataType : "json",
					data : {
						action: "linkToRecord"
					}
				};

				MyForm.prepare(formID, "people", options, true);
				MyFacture.customForm("#"+formID);

				$('.token-input-list').bind('click', function() {
					var radio = $(this).prev().find('input:radio');
					$('input:radio[name=po_linkedtype]:checked').removeAttr('checked');
					radio.attr('checked', true);
					MyFacture.customForm();
					People.switchLinkToForm();
				});

			}
		};

		MyWindow.load("people", {action: "linkToForm", linkedid : linkedid, linkedtype : linkedtype}, options);
	},


	switchLinkForm: function() {

		var checked = $('#third_choice input[name=link_third]:checked').val();
		var formID, relationType, getForm;

		switch (checked) {
			case "new":
			case "newthird":
			case "newThird":
				formID			= 'newThirdForm';
				relationType	= 'client';
				getForm			= true;
				break;
			case "newProspect":
				formID			= 'newProspectForm';
				relationType	= 'prospect';
				getForm			= true;
				break;
			case "newSupplier":
				formID			= 'newSupplierForm';
				relationType	= 'supplier';
				getForm			= true;
				break;
			case "newPeople":
				formID			= 'newPeopleForm';
				getForm			= false;
				break;
			default :
				getForm = false;
				break;
		}

		if (getForm && $('#'+formID).find('input').length === 0) {
			$.ajax({
				url			: '/?_f=third',
				type		: 'POST',
				dataType	: 'html',
				data		: {
					action			: 'formForRelated',
					relationType	: relationType,
					linkedType		: 'people'
				},
				beforeSend	: function() {
					$('.newThirdForm:not(#'+formID+')').slideUp(200).html('');
					$('#third_choice input[name=link_third]:checked').closest('.form-group').find('.ui-button-text').append('<i class="fa fa-spin fa-circle-o-notch" style="margin-left:20px;"></i>');
				},
				success		: function(data) {
					$('#third_choice input[name=link_third]:checked').closest('.form-group').find('.fa-spin').remove();

					$('#'+formID).html(data).slideDown(200, function(){
						if ($("#accounting_bloc").length) {
							Third.generateAuxiliaryAccountCode("#third_corp_name",
								"#thirdcontact_name", '#corp_auxCode', relationType, "#isPerson");
						}
						MyFacture.customForm('#'+formID);
                    });
                    //Add company searchForm
                    window.CompanySearch.getComponentCompanySearch('#third-companysearch-form', 'create');
				}
			});
		} else if (!getForm) {
			$('.newThirdForm').slideUp(200).html('');
		}
	},

	switchLinkToForm: function() {

		var checked	= $('#people_choice input[name=link_people]:checked').val();
		var formID	= 'newPeopleForm';

		switch (checked) {
			case "new":
			case "newPeople":
				$('#'+formID).slideDown(200, function(){
					MyFacture.customForm('#'+formID);
				});
				break;
			default :
				$('.newThirdForm').slideUp(200);
				break;
		}
	},

	switchContact : function(object, path) {
		var value = object.val();
		var data = value.split("##");

		if (data[0] != undefined && data[0] != '') {
			$('#' + path + '_name').val(data[0]);
		}
		if (data[1] != undefined && data[1] != '') {
			$('#' + path + '_email').val(data[1]);
		}
	},

	removeContactFromList : function(contact) {
		var wasMain = contact.find('.main-star .fa-star').length > 0;

		contact.remove();

		wasMain && $('.contact-list li').length > 0 && $('.contact-list li:first .main-star:first .fa').removeClass('fa-star-o').addClass('fa-star');
	},

	removeLinked : function(peopleid, linkedid) {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g('Délier le contact'),
            type		: 'warning',
            dialogClass : "white",
			buttons		: [
                {
					text : Loc.g("Annuler"),
					click : function() {
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Valider"),
					click : function() {
						$.ajax({
							url: '/?_f=people&action=removeLinked',
							type: 'POST',
							dataType: 'json',
							data: {
								peopleid: peopleid,
								linkedid: linkedid,
							},
							success: function(data) {
								$('#third_linkedList, .contact-list').find('li[tcid='+data.linkedid+']').fadeOut(300, function() {
									People.removeContactFromList($(this));
									$('.contact-list li').length === 0 && $('.contact-list').parent().find('.placeholder').fadeIn('fast');
									$('#third_linkedList li').length === 0 && $('#third_linkedList').parent().find('.placeholder').fadeIn('fast');
								});
								Utils.reload()
							},
							error: function(response) {
								if (response.responseJSON.error.code == 403) {
									Push.error(response.responseJSON.error.message)
								} else {
									Push.error(Loc.g("Une erreur est survenue, merci de contacter le support"));
								}
							}
						});

						$(this).dialog("close");
					}
				}
			]
		};

        MyWindow.alert(Loc.g("Souhaitez-vous délier le contact de la société ?"), options);
	},

	deleteOne : function(peopleid, context, csrfToken) {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'un contact"),
			type		: "warning",
            width		: 450,
            dialogClass: "white",
			buttons		: [
                {	text : Loc.g("Non"),
					click : function() {
						$(this).dialog("close");
					}
				},
                {	text : Loc.g("Oui"),
					click : function() {
						$.ajax({
							url: '/?_f=people&action=delete',
							type: 'POST',
							dataType: 'json',
							data: {
								peopleid: peopleid,
								csrf_delete: csrfToken,
							},
							success: function(data) {
								switch(context){
									case 'thirdOverview' :
										$('[peopleid='+data.peopleid+']').fadeOut(400, function(){
											People.removeContactFromList($(this));
										});
										break;
									case 'listing' :
										Listing.update('peopleListing');
										break;
									case 'newoverview' :
										Utils.reload();
										break;
									default :
										Utils.relocate('/?_f=people&action=list');
										break;
								}
							},
							error: function(response) {
								if (response.responseJSON && response.responseJSON.error.code == 403) {
									Push.error(response.responseJSON.error.message)
								} else {
									Push.error(Loc.g("Une erreur est survenue"));
								}
							}
						});

						$(this).dialog("close");
					}
				}
			]
		};

		switch (context) {
			case 'thirdOverview' :
				var showDeleteForm = function() {
					MyWindow.alert(Loc.g("Voulez-vous supprimer le contact?")+"<br /><br />"+Loc.g("Cette action supprimera le contact et tous ses liens avec d’autres sociétés.")+'<br />'+Loc.g('Si des clients, prospects ou fournisseurs particuliers sont liés à ce contact, ils seront supprimés')+"<br />"+Loc.g('Si vous souhaitez juste délier le contact du client, cliquez sur "Délier du client"'), options);
				};
				break;
			default :
				var showDeleteForm = function() {
					MyWindow.alert(Loc.g("Voulez-vous supprimer le contact?")+"<br /><br />"+Loc.g("Cette action supprimera le contact et tous ses liens avec d’autres sociétés."), options);
				};
				break;
		}

		if (People.hasDocLinked(peopleid)) {
			MyWindow.alert(Loc.g("Il existe des documents rattachés à ce contact, êtes-vous sûr de vouloir continuer?"), {
				resizable	: false,
				noclose		: true,
				title		: Loc.g("Des documents sont rattachés à ce contact"),
				type		: "warning",
                width		: 450,
                dialogClass : "white",
				buttons		: [
                    {
                        text : Loc.g("Non"),
                        click : function() {
                            $(this).dialog("close");
                        }
                    },
                    {
                        text : Loc.g("Oui"),
                        click : function() {
                            showDeleteForm();
                        }
                    }
                ]
			});
		} else {
			showDeleteForm();
		}
	},

	hasDocLinked : function(peopleid) {

		var hasDocLinked = false;

		var dataArray = {
			action 	: 'hasDocLinked',
			type 	: 'people',
			id 		: peopleid
		};

		$.ajax({
			url 		: '/?_f=people',
			type 		: 'POST',
			data 		: dataArray,
			dataType	: 'json',
			async		: false,
			success 	: function(data){
				hasDocLinked = data.hasDocLinked;
			}
		});

		return hasDocLinked;
	},

	updatePicture : function(data, context) {
		if (data.success) {
			switch (context) {
				case 'overview' :
					MyFacture.post('people',  {action : 'updatePicture', picture : data.fullname, peopleid : $('#peopleid').val()}, function(datajson) {
						$('.logo').find('.avatar').fadeOut(300, function() {
							$(this).parent().empty().append('<span class="avatar avatar-xxbig avatar-picture"><img src="'+datajson.picture.value+'" /></span>');
						});
					}, 'json');
					break;
				default :
					$('#peoplePicture').find('.avatar').fadeOut(300, function() {
						$(this).parent().empty().append('<span class="avatar avatar-xxbig avatar-picture"><img src="'+data.file+'" /></span>');
					});
					$("input[name*='pic']").val(data.fullname);
					MyFacture.customForm($('.tc_deletePicture'));
					break;
			}
		}
	},

	deletePicture : function(peopleid) {
		MyFacture.post('people',  {action : 'deletePicture', peopleid : peopleid}, function(datajson) {
			$('.logo').find('.avatar').fadeOut(300, function() {
				$(this).parent().empty().append('<span class="avatar avatar-big">'+datajson.picture.value+'</span>');
			});
		}, 'json');

	},

	deletepeoplesGroupAction: function(rowSelection) {


		var msg = Loc.g("Vous allez supprimer les contacts sélectionnés, cette action est irréversible.");

		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 400,
			title		: Loc.g("Supprimer les contacts"),
			buttons: [
                {
                    text: Loc.g("Annuler"),
					'class'	: "btn btn-default",
                    click: function() {
                        $(this).dialog("close");
                    }
                },
                {
					text: Loc.g("Supprimer"),
					'class'	: "btn btn-primary",
					click: function() {
						MyWindow.wait('alertWindow');
						MyFacture.post('people', {action: "deletePeoples", rowSelection: rowSelection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		var showDeleteForm = function() {
			MyWindow.alert(msg, options);
		};

		if (People.hasDocLinked(rowSelection)) {
			MyWindow.alert(Loc.g("Il existe des documents rattachés à ce contact, êtes-vous sûr de vouloir continuer?"), {
				resizable	: false,
				noclose		: true,
				title		: Loc.g("Des documents sont rattachés aux contacts sélectionnés"),
                dialogClass: "white",
				width		: 450,
				buttons		: [
					{
						text : Loc.g("Non"),
						click : function() {
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Oui"),
						click : function() {
							showDeleteForm();
						}
					}
				]
			});
		} else {
			showDeleteForm();
		}


	},

	updateArchive: function(id, newState) {

		var options = {
			type: "warning",
			dialogClass: "white",
			title: newState === "Y" ? Loc.g("Désarchiver") : Loc.g("Archiver"),
			buttons: [
                {
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
                {
					text: Loc.g("Valider"),
					click: function() {
						$.ajax({
							url: '/?_f=people&action=updateArchive',
							type: 'POST',
							dataType: 'json',
							data: {
								people: id,
								activ: newState,
							},
							success: function(data) {
								Utils.reload();
							},
							error: function(response) {
								if (response.responseJSON.error.code == 403) {
									Push.error(response.responseJSON.error.message)
								} else {
									Push.error(Loc.g("Une erreur est survenue, merci de contacter le support"));
								}
							}
						});
					}
				}
			]
        };

        var textPopup = '';
        if (newState === "Y") {
            textPopup = "Vous pouvez restaurer une société ou un contact pour le rendre disponible dans les listes ou dans les résultats de recherche."
        } else {
            textPopup = "Vous pouvez archiver une société ou un contact pour ne plus le faire apparaître dans les listes ou dans les résultats de recherche. Vous pourrez à l'avenir le restaurer si besoin."
        }
        MyWindow.alert(textPopup, options);
	},

	updateState: function(rowSelection) {

		var options = {
			title: Loc.g("Archiver / désarchiver"),
			buttons: [
                {
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
                {
					text: Loc.g("Enregistrer"),
					click: function() {
						$("#updateStateForm").submit();
					}
				}
			],
			width: 500,
			callback: function() {

                var params   = { 
					'action': 'updateStateRecord', 
					'peoples': rowSelection 
				};

                var options = {
                    method: "POST",
					success: function(data) {

						MyWindow.close();

						var msg = "";

						if (data.modified.length > 0) {

							var res = "<div class='table' style='margin-top:6px;'><table>";
							for (var i in data.modified) {
								res += "<tr><td>" + data.modified[i].forename + " " + data.modified[i].name + "</td></tr>";
							}
							res += "</table></div>";

                            msg = Loc.g("Les contacts suivants ont été") + ' ' + (data.state_activ === 'Y' ? Loc.g('désarchivés') : Loc.g('archivés')) + " : <br/>" + res;

						} else {
							msg = "<p class='alert alert-info'>" + Loc.g("Aucun élément n‘a été mis à jour.") + "</p>";
						}

						MyWindow.alert(
								msg,
								{
									title	: Loc.g('Archiver / désarchiver'),
									type	: 'info',
									buttons	: [
										{
											text: Loc.g("Ok"),
											click: function() {
                                                $(this).dialog("close");
												$("#groupedActionContainer").hide();
												Utils.reload();
											}
										}
									]
								}
						);
					},
                    dataType: "json",
                    data: params
				};

				MyForm.prepare("updateStateForm", "people", options, true);
				MyFacture.customForm();
			}
		};
		MyWindow.load('thirds', {action: "updateStateForm"}, options);
	},

	switchFilterCampaign : function() {
		if ($('#peopleListing_filter_campaignSearch').val() == 'nothing') {
			$('.campaignType').addClass('hidden');
			$('.campaignSubscription').addClass('hidden');
			$('.campaignPeriod').addClass('hidden');
		} else {
			$('.campaignType').removeClass('hidden');
			$('.campaignSubscription').removeClass('hidden');
			$('.campaignPeriod').removeClass('hidden');
		}
		if ($('#peopleListing_filter_campaignSearch').val() == 'history') {
			$('.campaignPeriod').removeClass('hidden');
		} else {
			$('.campaignPeriod').addClass('hidden');
		}
	}
};
